var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('content-loader'):_c('start-vacancy',_vm._g({attrs:{"vacancy":_vm.preparedVacancy,"multiple":_vm.isMultipleMode,"child-id":_vm.childId,"vacancy-request":_vm.vacancyRequest,"offers":_vm.offers,"reopen":_vm.reopen,"handle-submit":_vm.handleSubmit},on:{"cancel":_vm.handleCancel}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }